export const PARTNER_REQUEST_ROWS_PER_PAGE = 5;

export const PARTNER_REQUEST_RECEIVED_ROWS_PER_PAGE = 10;

export const COMPONENTS_TABLE_ROWS_PER_PAGE = 6;

export const SUPPLY_CHAIN_TABLE_ROWS_PER_PAGE = 5;

export const ACTIVITIES_TABLE_ROWS_PER_PAGE = 10;

export const PREVIEW_LATEST_ITEMS = 3;

export const SITES_TABLE_ROWS_PER_PAGE = 15;

export const PLOTS_PER_PAGE = 100;

export const PLOTS_PER_PLOT_LIBRARY_PAGE = 10;

export const INITIAL_TABLE_ROWS = 100;

export const SUPPLY_CHAINS_PER_PAGE = 15;

export const COMPONENTS_PER_PAGE = 15;

export const COMPONENT_CHAINS_PER_PAGE = 15;

export const PRODUCTS_PER_PAGE = 10;

export const IMPACT_CLAIMS_PER_PAGE = 10;

export const DOCUMENTS_PER_PAGE = 15;

export const DATASETS_PER_PAGE = 15;
